export default __webpack_public_path__ + "static/media/scroll tracing bar.fb5e6c22.webp";